import { toast } from "react-toastify";
import { payLatter } from "./payLatter";
import { payNow } from "./payNow";

const MPESA_PAYMENT_METHOD_ID = 4;

const normalizeKenyanPhone = (phone) => {
  let mobile = String(phone || "").replace(/\D/g, "");

  if (mobile.startsWith("254") && mobile.length === 12) {
    // Already in international format.
  } else if (mobile.startsWith("0") && mobile.length === 10) {
    mobile = `254${mobile.slice(1)}`;
  } else if (mobile.length === 9) {
    mobile = `254${mobile}`;
  }

  if (!/^254[17]\d{8}$/.test(mobile)) {
    return null;
  }

  return mobile;
};

export const PaymentHelper = async (
  allBookingInformation,
  dispatch,
  history
) => {
  const {
    passengerInformation = {},
    contactDetails = {},
    passengers = [],
    values = {},
    mpesaPhone,
    paymentStutas,
    paymentGateway,
    token,
    coupon,
  } = allBookingInformation || {};

  const firstName = String(
    passengerInformation.first_name || ""
  ).trim();

  const email = String(
    contactDetails.email ??
      passengerInformation.login_email ??
      ""
  ).trim();

  if (!firstName) {
    toast.error("Passenger first name is required.");
    throw new Error("Passenger first name is required.");
  }

  if (
    paymentStutas !== "Pay Now" &&
    paymentStutas !== "Pay Latter"
  ) {
    throw new Error("Invalid payment status.");
  }

  let normalizedMpesaPhone = "";

  if (paymentStutas === "Pay Now") {
    if (!String(mpesaPhone || "").trim()) {
      toast.error("Please enter your M-PESA phone number.");
      throw new Error("M-PESA phone number is required.");
    }

    if (Number(paymentGateway) !== MPESA_PAYMENT_METHOD_ID) {
      toast.error("M-PESA is the only available payment method.");
      throw new Error("Invalid payment method.");
    }

    normalizedMpesaPhone = normalizeKenyanPhone(mpesaPhone);

    if (!normalizedMpesaPhone) {
      toast.error(
        "Enter a valid Kenyan M-PESA number, e.g. 0712345678."
      );
      throw new Error("Invalid Kenyan M-PESA phone number.");
    }
  }

  const bookingData = new FormData();

  bookingData.append("login_email", email);

  // Keep the contact mobile separate from the M-PESA payment number.
  bookingData.append(
    "login_mobile",
    String(passengerInformation.login_mobile || "").trim()
  );

  bookingData.append(
    "first_name",
    `${passengerInformation.gender || "Mr"} ${firstName}`
  );

  bookingData.append(
    "last_name",
    String(passengerInformation.last_name || "").trim()
  );

  bookingData.append(
    "id_type",
    passengerInformation.id_type || "Nid"
  );

  bookingData.append(
    "country_id",
    passengerInformation.country_id || ""
  );

  bookingData.append(
    "id_number",
    passengerInformation.id_number || ""
  );

  bookingData.append("address", "");
  bookingData.append("city", "");
  bookingData.append("zip_code", "");
  bookingData.append("coupon_code", coupon || "");

  if (contactDetails.notificationChannel) {
    bookingData.append(
      "notification_channel",
      contactDetails.notificationChannel
    );
  }

  // Store the shared passenger list once for the booking.
  bookingData.append(
    "passengers",
    JSON.stringify(Array.isArray(passengers) ? passengers : [])
  );

  // Preserve the legacy form values for existing backend integrations.
  bookingData.append(
    "passenger_values",
    JSON.stringify(values || {})
  );

  bookingData.append(
    "passenger_count",
    String(
      Array.isArray(passengers) && passengers.length
        ? passengers.length
        : 1
    )
  );

  // The M-PESA number is distinct from the passenger/contact mobile.
  if (normalizedMpesaPhone) {
    bookingData.append("mpesa_phone", normalizedMpesaPhone);
  }

  const baseUrl =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";

  bookingData.append(
    "callback_url",
    `${baseUrl}/ticket-tracking`
  );

  try {
    if (paymentStutas === "Pay Latter") {
      return await payLatter(
        bookingData,
        allBookingInformation,
        dispatch,
        history
      );
    }

    return await payNow(
      bookingData,
      {
        ...allBookingInformation,
        passengers,
        mpesaPhone: normalizedMpesaPhone,
        paymentGateway: MPESA_PAYMENT_METHOD_ID,
        paymentStutas: "Pay Now",
      },
      dispatch,
      history
    );
  } catch (error) {
    console.error("PaymentHelper error:", error);
    throw error;
  }
};
